















































































































































































































































































































































































































































































































































































































import store from "../store";
import { inputs, printPage } from "../mixins/mixins";

export default {
  mixins: [inputs, printPage],

  data() {
    return {
      title: "Step 2",
      ss: store.state,
      panels: [0, 1, 2],
      readMoreActivated: [false, false],
      update: 0
    };
  },

  computed: {
    avgGrowingSeason: {
      get: function() {
        return store.state.step2.avgGrowingSeason;
      },
      set: function(this: any, newValue: any) {
        store.state.step2.avgGrowingSeason = parseFloat(newValue);
      }
    },

    maxP: (): number => {
      return store.state.step1.type === "Colwell"
        ? store.state.step1.colwellP
        : store.state.step1.olsenP;
    },

    carryingCapacityLarge: function(): number {
      let newLargeCapacity = 3.41 * store.state.step2.avgGrowingSeason - 8.38;
      store.state.step2.preCarryingCapacity.large = newLargeCapacity;
      return newLargeCapacity;
    },

    carryingCapacitySmall: function(): number {
      let newSmallCapacity = 3.42 * store.state.step2.avgGrowingSeason - 5.63;
      store.state.step2.preCarryingCapacity.small = newSmallCapacity;
      return newSmallCapacity;
    },

    potCarryingCapacity: {
      get: function() {
        return store.state.step2.potCarryingCapacity;
      },
      set: function(this: any, newValue: any) {
        store.state.step2.potCarryingCapacity = parseFloat(newValue);
      }
    },

    // Target value rules dependant on target type selection
    targetRules: function(this: any) {
      const rules: any[] = [];
      if (store.state.step2.type === "stockingRate") {
        const rule = (v: any) =>
          v <= this.potCarryingCapacity ||
          "For long-term planning, you cannot select a target value for stocking rate which exceeds the carrying capacity of your pasture which is currently set at " +
            this.potCarryingCapacity;
        rules.push(rule);
      }
      if (store.state.step2.type === "soilFertility") {
        const rule = (v: any) =>
          v < 100 || "The value you have entered does not seem realistic.";
        rules.push(rule);
      }
      return rules;
    },

    // Step A

    chartData1: function() {
      return {
        datasets: [
          {
            type: "line",
            label: "Large paddocks",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            borderDash: ["4", "2"],
            pointStyle: "line",
            data: [
              {
                x: 4,
                y: parseFloat(store.state.step2.preCarryingCapacity.large)
              },
              {
                x: parseFloat(store.state.step2.avgGrowingSeason),
                y: parseFloat(store.state.step2.preCarryingCapacity.large)
              }
            ]
          },
          {
            type: "line",
            label: "Small paddocks",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            borderDash: ["4", "2"],
            pointStyle: "line",
            data: [
              {
                x: 4,
                y: parseFloat(store.state.step2.preCarryingCapacity.small)
              },
              {
                x: parseFloat(store.state.step2.avgGrowingSeason),
                y: parseFloat(store.state.step2.preCarryingCapacity.small)
              }
            ]
          },
          {
            type: "line",
            label: "Avg growing season",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            borderDash: ["4", "2"],
            pointStyle: "line",
            data: [
              {
                x: parseFloat(store.state.step2.avgGrowingSeason),
                y: 0
              },
              {
                x: parseFloat(store.state.step2.avgGrowingSeason),
                y: parseFloat(store.state.step2.preCarryingCapacity.small)
              }
            ]
          },
          {
            type: "scatter",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            pointBackgroundColor: "#F44336",
            pointBorderColor: "#F44336",
            pointStyle: "triangle",
            pointRadius: 5,
            rotation: 270,
            data: [
              {
                x: 4.05,
                y: parseFloat(store.state.step2.preCarryingCapacity.large)
              },
              {
                x: 4.05,
                y: parseFloat(store.state.step2.preCarryingCapacity.small)
              }
            ]
          },
          {
            type: "scatter",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            pointBackgroundColor: "#F44336",
            pointBorderColor: "#F44336",
            pointStyle: "triangle",
            pointRadius: 5,
            data: [
              {
                x: parseFloat(store.state.step2.avgGrowingSeason),
                y: parseFloat(store.state.step2.preCarryingCapacity.large) - 0.5
              },
              {
                x: parseFloat(store.state.step2.avgGrowingSeason),
                y: parseFloat(store.state.step2.preCarryingCapacity.small) - 0.5
              }
            ]
          },
          {
            type: "line",
            label: "Paddock < 20ha",
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            borderDash: ["20", "10"],
            pointStyle: "line",
            data: [
              {
                x: 5,
                y: 11.5
              },
              {
                x: 10,
                y: 28.6
              }
            ]
          },
          {
            type: "line",
            label: "Paddock > 20ha",
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            data: [
              {
                x: 5,
                y: 8.7
              },
              {
                x: 10,
                y: 25.7
              }
            ]
          }
        ]
      };
    },

    chartOptions1: function() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            type: "linear",
            display: true,
            position: "bottom",
            beginAtZero: false,
            min: 4,
            max: 12,
            title: {
              display: true,
              text: "Growing season length (months)",
              color: "#000",
              font: {
                size: 14
              },
              padding: {
                top: 15
              }
            },
            ticks: {
              color: "#000",
              stepSize: 0.5,
              callback: function(val: any, index: number) {
                return index % 2 === 0 ? val : "";
              }
            },
            grid: {
              color: "rgba(0,0,0,0.05)",
              tickColor: "#000",
              borderColor: "#000"
            }
          },
          y: {
            type: "linear",
            display: true,
            position: "left",
            beginAtZero: true,
            title: {
              display: true,
              text: "Potential stocking rate (DSE/ha)",
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            grid: {
              color: "rgba(0,0,0,0.05)",
              tickColor: "#000",
              borderColor: "#000"
            }
          }
        },
        plugins: {
          chartCustomization: {
            borderColor: "rgba(0,0,0,0.1)",
            borderWidth: 1
          },
          tooltip: {
            filter: function(tooltipItem: any) {
              return tooltipItem.dataset.pointStyle != "triangle";
            },
            callbacks: {
              label: function(context: any) {
                let xLabel: string = "";
                let yLabel: string = "";
                if (context.parsed.x !== null) {
                  xLabel += parseFloat(context.parsed.x.toFixed(2));
                }
                if (context.parsed.y !== null) {
                  yLabel += parseFloat(context.parsed.y.toFixed(2));
                }
                return (
                  context.dataset.label + ": (" + xLabel + ", " + yLabel + ")"
                );
              },
              labelColor: function(context: any) {
                let dataset =
                  context.chart.config.data.datasets[context.datasetIndex];
                return {
                  borderColor:
                    dataset.backgroundColor != "transparent"
                      ? dataset.backgroundColor
                      : dataset.borderColor,
                  backgroundColor:
                    dataset.backgroundColor != "transparent"
                      ? dataset.backgroundColor
                      : dataset.borderColor,
                  borderRadius: 5
                };
              },
              title: function(context: any) {
                return null;
              }
            }
          },
          legend: {
            display: true,
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              color: "#000",
              font: {
                size: 12
              },
              filter: function(legendItem: any) {
                return legendItem.text;
              },
              generateLabels: function(chart: any) {
                let data = chart.data;
                let legends = Array.isArray(data.datasets)
                  ? data.datasets.map(function(dataset: any, i: number) {
                      return {
                        text: dataset.label,
                        datasetIndex: i,
                        fillStyle: dataset.borderDash
                          ? "transparent"
                          : dataset.backgroundColor,
                        hidden: !chart.isDatasetVisible(i),
                        strokeStyle: dataset.borderColor,
                        pointStyle: dataset.pointStyle,
                        lineDash: dataset.borderDash ? ["4", "2"] : ["0", "0"],
                        lineWidth: 2,
                        borderRadius: dataset.type === "scatter" ? 6 : 0,
                        rotation:
                          dataset.label === "Avg growing season"
                            ? 270
                            : dataset.label === "Paddock > 20ha" ||
                              dataset.label === "Paddock < 20ha"
                            ? 335
                            : 0
                      };
                    }, this)
                  : [];
                return legends;
              }
            }
          }
        }
      };
    },

    // Step B - Carrying Capacity of unfertilised pastures

    chartData2: function() {
      const pcc = parseFloat(store.state.step2.potCarryingCapacity);
      const tcc = parseFloat(store.state.step2.typical.carryingCapacity);
      const typicalPTest = parseFloat(store.state.step2.typical.pTest);
      const criticalP = (store.state.step1.type === "Colwell" ? store.state.step1.colwellP : store.state.step1.olsenP)

      // Calculate critical P & 95% max x value

      // y = (m * x) + c
      // m = y2 - y1 / x2 - x1
      // c = y - mx

      let m = ((pcc * 0.95) - tcc) / (criticalP - typicalPTest)
      let c = tcc - (m * typicalPTest)
      let x = (pcc - c) / m

      return {
        datasets: [
          {
            type: "line",
            label: "Max",
            showLabel: true,
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            borderDash: ["20", "10"],
            data: [
              {
                x: x,
                y: parseFloat(store.state.step2.potCarryingCapacity)
              },
              {
                x:
                  (store.state.step1.type === "Colwell"
                    ? store.state.step1.colwellP
                    : store.state.step1.olsenP) * 1.8,
                y: parseFloat(store.state.step2.potCarryingCapacity)
              }
            ]
          },
          {
            type: "line",
            label: "95% of max",
            showLabel: true,
            backgroundColor: "#4CAF50",
            borderColor: "#4CAF50",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            borderDash: ["4", "2"],
            order: 1,
            data: [
              {
                x: 0,
                y: parseFloat(store.state.step2.potCarryingCapacity) * 0.95
              },
              {
                x:
                  (store.state.step1.type === "Colwell"
                    ? store.state.step1.colwellP
                    : store.state.step1.olsenP) * 1.8,
                y: parseFloat(store.state.step2.potCarryingCapacity) * 0.95
              }
            ]
          },
          {
            type: "scatter",
            label: "Current stocking rate",
            showLabel: true,
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            pointBackgroundColor: "#F44336",
            pointBorderColor: "#F44336",
            pointStyle: "circle",
            pointRadius: 5,
            data: [
              {
                x: parseFloat(store.state.step1.value),
                y: parseFloat(store.state.step2.stockingRateCurrent)
              }
            ]
          },
          {
            label: 'Critical P & 95% max',
            showLabel: true,
            type: "scatter",
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            pointBackgroundColor: "#1976d2",
            pointBorderColor: "#1976d2",
            pointStyle: "circle",
            pointRadius: 5,
            data: [
              {
                x: (store.state.step1.type === "Colwell"
                    ? store.state.step1.colwellP
                    : store.state.step1.olsenP),
                y: parseFloat(store.state.step2.potCarryingCapacity) * 0.95
              }
            ]
          },
          {
            label: 'Low fertility pasture',
            showLabel: true,
            type: "scatter",
            backgroundColor: "#FFFFFF",
            borderColor: "#1976d2",
            pointBackgroundColor: "#FFFFFF",
            pointBorderColor: "#1976d2",
            pointStyle: "circle",
            pointRadius: 5,
            data: [
              {
                x: parseFloat(store.state.step2.typical.pTest),
                y: parseFloat(store.state.step2.typical.carryingCapacity) 
              }
            ]
          },
          {
            type: "line",
            label: store.state.step1.type + " P",
            showLabel: false,
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            order: 1,
            data: [
              {
                x: parseFloat(store.state.step2.typical.pTest),
                y: parseFloat(store.state.step2.typical.carryingCapacity)
              },
              {
                x: x,
                y: parseFloat(store.state.step2.potCarryingCapacity)
              }
            ]
          },
          /*{
            type: 'scatter',
            label: 'Current carrying capacity',
            backgroundColor: '#1976d2',
            borderColor: '#1976d2',
            showLine: false,
            data: [
              {
                x: parseFloat(store.state.step1.value),
                y: parseFloat(store.state.step2.potential.carryingCapacity)
              }
            ]
          },*/
          {
            hidden: true,
            type: "line",
            label:
              store.state.step2.type === "stockingRate"
                ? "Target value"
                : "Predicted carrying capacity",
            showLabel: false,
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            borderDash: ["4", "2"],
            data: (
              store.state.step2.type === "stockingRate"
              ? parseFloat(store.state.step2.fertilityTarget)
              : parseFloat(store.state.step2.stockingRateTarget)
            ) > 0
            ? [
              {
                x: 0,
                y:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.target)
                    : parseFloat(store.state.step2.stockingRateTarget)
              },
              {
                x:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.fertilityTarget)
                    : parseFloat(store.state.step2.target),
                y:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.target)
                    : parseFloat(store.state.step2.stockingRateTarget)
              }
            ]
            : []
          },
          {
            hidden: true,
            type: "line",
            label:
              store.state.step2.type === "stockingRate"
                ? "Predicted P fertility requirement"
                : "Target value",
            showLabel: false,
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            borderDash: ["4", "2"],
            data: (
              store.state.step2.type === "stockingRate"
              ? parseFloat(store.state.step2.fertilityTarget)
              : parseFloat(store.state.step2.stockingRateTarget)
            ) > 0
            ? [
              {
                x:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.fertilityTarget)
                    : parseFloat(store.state.step2.target),
                y: 0
              },
              {
                x:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.fertilityTarget)
                    : parseFloat(store.state.step2.target),
                y:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.target)
                    : parseFloat(store.state.step2.stockingRateTarget)
              }
            ]
            : []
          },
          {
            hidden: true,
            type: "scatter",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            pointBackgroundColor: "#F44336",
            pointBorderColor: "#F44336",
            pointStyle: "triangle",
            pointRadius: 5,
            rotation: store.state.step2.type === "stockingRate" ? 90 : 270,
            data: (
              store.state.step2.type === "stockingRate"
              ? parseFloat(store.state.step2.fertilityTarget)
              : parseFloat(store.state.step2.stockingRateTarget)
            ) > 0
            ? [
              {
                x: 0.5,
                y:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.target)
                    : parseFloat(store.state.step2.stockingRateTarget)
              }
            ]
            : []
          },
          {
            hidden: true,
            type: "scatter",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            pointBackgroundColor: "#F44336",
            pointBorderColor: "#F44336",
            pointStyle: "triangle",
            pointRadius: 5,
            rotation: store.state.step2.type === "stockingRate" ? 180 : 0,
            data: (
              store.state.step2.type === "stockingRate"
              ? parseFloat(store.state.step2.fertilityTarget)
              : parseFloat(store.state.step2.stockingRateTarget)
            ) > 0
            ? [
              {
                x:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.fertilityTarget)
                    : parseFloat(store.state.step2.target),
                y:
                  (store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.target)
                    : parseFloat(store.state.step2.stockingRateTarget)) - 0.5
              }
            ]
            : []
          },
          {
            hidden: true,
            type: "scatter",
            backgroundColor: "#F44336",
            borderColor: "#F44336",
            pointBackgroundColor: "#F44336",
            pointBorderColor: "#F44336",
            pointStyle: "triangle",
            pointRadius: 5,
            rotation: store.state.step2.type === "stockingRate" ? 180 : 0,
            data: (
              store.state.step2.type === "stockingRate"
              ? parseFloat(store.state.step2.fertilityTarget)
              : parseFloat(store.state.step2.stockingRateTarget)
            ) > 0
            ? [
              {
                x:
                  store.state.step2.type === "stockingRate"
                    ? parseFloat(store.state.step2.fertilityTarget)
                    : parseFloat(store.state.step2.target),
                y: 0.5
              }
            ]
            : []
          }
        ]
      };
    },

    chartOptions2: function() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            type: "linear",
            display: true,
            position: "bottom",
            title: {
              display: true,
              text:
                "Soil P fertility level (mg " +
                store.state.step1.type +
                " P/kg soil)",
              color: "#000",
              font: {
                size: 14
              },
              padding: {
                top: 15
              }
            },
            ticks: {
              color: "#000",
              stepSize: 5,
              callback: function(val: any, index: number) {
                return index % 2 === 0 ? val : "";
              }
            },
            grid: {
              color: "rgba(0,0,0,0.05)",
              tickColor: "#000",
              borderColor: "#000"
            }
          },
          y: {
            type: "linear",
            display: true,
            position: "left",
            grace: '20%',
            beginAtZero: true,
            title: {
              display: true,
              text: "Carrying capacity (DSE/ha)",
              color: "#000",
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            ticks: {
              color: "#000",
              stepSize: 2.5,
              callback: function(val: any, index: number) {
                return index % 2 === 0 ? val : "";
              }
            },
            grid: {
              color: "rgba(0,0,0,0.05)",
              tickColor: "#000",
              borderColor: "#000"
            }
          }
        },
        plugins: {
          chartCustomization: {
            borderColor: "rgba(0,0,0,0.1)",
            borderWidth: 1
          },
          tooltip: {
            filter: function(tooltipItem: any) {
              return (
                tooltipItem.dataset.label &&
                tooltipItem.dataset.pointStyle != "triangle"
              );
            },
            callbacks: {
              label: function(context: any) {
                let xLabel: string = "";
                let yLabel: string = "";
                if (context.parsed.x !== null) {
                  xLabel += parseFloat(context.parsed.x.toFixed(2));
                }
                if (context.parsed.y !== null) {
                  yLabel += parseFloat(context.parsed.y.toFixed(2));
                }
                return (
                  context.dataset.label + ": (" + xLabel + ", " + yLabel + ")"
                );
              },
              labelColor: function(context: any) {
                let dataset =
                  context.chart.config.data.datasets[context.datasetIndex];
                return {
                  borderColor:
                    dataset.backgroundColor != "transparent"
                      ? dataset.backgroundColor
                      : dataset.borderColor,
                  backgroundColor:
                    dataset.backgroundColor != "transparent"
                      ? dataset.backgroundColor
                      : dataset.borderColor,
                  borderRadius: 5
                };
              },
              title: function(context: any) {
                return null;
              }
            }
          },
          legend: {
            display: true,
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              color: "#000",
              font: {
                size: 12
              },
              filter: function(legendItem: any) {
                return legendItem.text;
              },
              generateLabels: function(chart: any) {
                let data = chart.data;
                let legends = Array.isArray(data.datasets)
                  ? data.datasets.map(function(dataset: any, i: number) {
                      return {
                        text: dataset.showLabel === true ? dataset.label : "",
                        datasetIndex: i,
                        fillStyle: dataset.borderDash
                          ? "transparent"
                          : dataset.backgroundColor,
                        hidden: !chart.isDatasetVisible(i),
                        strokeStyle: dataset.borderColor,
                        pointStyle: dataset.pointStyle,
                        lineDash: dataset.borderDash ? ["4", "2"] : ["0", "0"],
                        lineWidth: 2,
                        borderRadius: dataset.type === "scatter" ? 6 : 0,
                        rotation:
                          store.state.step2.type === "stockingRate" &&
                          dataset.label === "Predicted P fertility requirement"
                            ? 270
                            : store.state.step2.type === "soilFertility" &&
                              dataset.label === "Target value"
                            ? 270
                            : dataset.label === "Colwell P" ||
                              dataset.label === "Olsen P"
                            ? 335
                            : 0
                      };
                    }, this)
                  : [];
                return legends;
              }
            }
          }
        }
      };
    },

    // Step C - Management targets

    chartData3: function() {
      let chart:any = JSON.parse(JSON.stringify(this.chartData2))
      chart.datasets.forEach((e:any) => {
        e.hidden = false
      })
      return chart
    }
  },

  methods: {
    // Validate growing season length
    validateGrowingSeason: async function(this: any, value: any) {
      value = parseFloat(value);
      if (value > 12 || value < 5 || isNaN(value)) {
        if (
          await this.$refs.confirm.open(
            "Value outside expected range",
            "The relationship between carrying capacity and growing season is based on data for growing seasons between 5 and 12 months. Entering a growing season of " +
              (value < 5 ? "less than 5 " : "more than 12 ") +
              "months may result in a poor estimate of carrying capacity.",
            {
              color: "red",
              cta: "Accept value"
            }
          )
        ) {
          // Accept value
          this.avgGrowingSeason = value;
        } else {
          // If value is less than minimum
          if (value < 5) {
            this.avgGrowingSeason = 5;
          }
          // If value is greater than maximum
          if (value > 12) {
            this.avgGrowingSeason = 12;
          }
        }
      }
    },

    // Validates that the potential carrying capacity is within range
    validatePCC: async function(this: any, value: any) {
      value = parseFloat(value);
      if (
        value > this.carryingCapacitySmall ||
        value < this.carryingCapacityLarge ||
        isNaN(value)
      ) {
        if (
          await this.$refs.confirm.open(
            "Value outside expected range",
            "The value you have entered for carrying capacity lies outside the predicted range. Please consider carefully whether the value you have entered is realistic.",
            {
              color: "red",
              cta: "Accept value"
            }
          )
        ) {
          // Accept value
          this.potCarryingCapacity = value;
        } else {
          // If value is less than minimum
          if (value > this.carryingCapacitySmall) {
            this.potCarryingCapacity = this.carryingCapacitySmall;
            return this.potCarryingCapacity;
          }
          // If value is greater than maximum
          if (value < this.carryingCapacityLarge) {
            this.potCarryingCapacity = this.carryingCapacityLarge;
            return this.potCarryingCapacity;
          }
        }
      }
    },

    // Calculate the fertility target
    fertilityTarget: function(this: any): number {
      let maxP = this.maxP;
      let unfertilisedP = parseFloat(store.state.step2.typical.pTest);
      // let potentialCC = parseFloat(store.state.step2.potCarryingCapacity); // blue dashed line
      let percentOfMax = parseFloat(store.state.step2.potCarryingCapacity) * 0.95; // green dashed line
      let unfertilisedCC = parseFloat(
        store.state.step2.typical.carryingCapacity
      );
      let targetValue = parseFloat(store.state.step2.target);

      /*let target: number = Math.min(
        maxP,
        unfertilisedP +
          ((maxP - unfertilisedP) / (percentOfMax - unfertilisedCC)) *
            (targetValue - unfertilisedCC)
      );*/

      let target: number = 
        (unfertilisedP +
          ((maxP - unfertilisedP) / (percentOfMax - unfertilisedCC)) *
            (targetValue - unfertilisedCC))

      target = target > 0 ? target : 0;
      store.state.step2.fertilityTarget = target;
      return target;
    },

    // Calculate the stocking rate target
    stockingTarget: function(this: any): number {
      let maxP = this.maxP;
      let unfertilisedP = parseFloat(store.state.step2.typical.pTest);
      let potentialCC = parseFloat(store.state.step2.potCarryingCapacity) * 0.95;
      let unfertilisedCC = parseFloat(
        store.state.step2.typical.carryingCapacity
      );
      let targetValue = parseFloat(store.state.step2.target);
      let target: number = Math.min(
        potentialCC / 0.95,
        unfertilisedCC +
          ((potentialCC - unfertilisedCC) / (maxP - unfertilisedP)) *
            (targetValue - unfertilisedP)
      );
      target = target > 0 ? target : 0;
      store.state.step2.stockingRateTarget = target;
      return target;
    },

    // Target value rules dependant on target type selection
    validateTarget: async function(this:any, value:number) {
      if (store.state.step2.type === "soilFertility") {
        if (value >= 100) {
          if (await this.$refs.confirm.open(
             "Value outside expected range",
            "The value you have entered does not seem realistic.",
            {
              color: "red",
              cta: "Retry"
            }
          )) {
            store.state.step2.target = 50
          } else {
            store.state.step2.target = 50
          }
        } else {
          store.state.step2.target = value
        }
      }
      if (store.state.step2.type === "stockingRate") {
        if (value > this.potCarryingCapacity) {
          if (await this.$refs.confirm.open(
            "Value outside expected range",
            "For long-term planning, you cannot select a target value for stocking rate which exceeds the carrying capacity of your pasture which is currently set at " +
            this.potCarryingCapacity,
            {
              color: "red",
              cta: "Retry"
            }
          )) {
            store.state.step2.target = parseFloat((this.potCarryingCapacity * 0.95).toFixed(1))
          } else {
            store.state.step2.target = parseFloat((this.potCarryingCapacity * 0.95).toFixed(1))
          }
        } else {
          store.state.step2.target = value
        }
      }
      store.dispatch('updateStep2', store.state.step2)
      this.update += 1
    },

    // Read more toggle
    activateReadMore: function(this: any, index: number) {
      this.readMoreActivated.splice(index, 1, !this.readMoreActivated[index]);
    }
  },

  store
};
